module.exports = __webpack_public_path__ + "img/empalme.69c8e8dd.png";